import {
  DeleteCvRequest,
  DeleteCvResponse,
  GetConstansResponse,
  GetLocationResponse,
  UploadCvRequest,
  UploadCvResponse,
  UploadCvSourceDataResponse,
  UploadLinkedinSourceDataResponse,
} from '@internal/types/api';

import { httpClient, mutationEndpoint, queryEndpoint } from '../system';

const getConstants = queryEndpoint({
  entity: 'constants',
  queryKey: () => ['constants'],
  queryFn: (_, nextContext?) =>
    httpClient.auto<GetConstansResponse>({
      url: '/api/constants',
      method: 'GET',
      nextContext,
    }),
  defaultValue: null,
  nullable: true,
});

const getLocation = queryEndpoint({
  entity: 'location',
  queryKey: () => ['location'],
  queryFn: (_, nextContext?) =>
    httpClient.auto<GetLocationResponse>({
      url: '/api/escape-the-matrix/get-location',
      method: 'GET',
      nextContext,
    }),
  defaultValue: null,
  nullable: true,
});

const uploadCv = mutationEndpoint({
  actionName: 'uploadCv',
  mutationKey: ['upload-cv'],
  mutationFn: ({ apiKey, cv }: UploadCvRequest & { apiKey: string }) =>
    httpClient.auto<UploadCvResponse>({
      url: `/upload/${apiKey}/cv`,
      method: 'POST',
      data: cv,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
  onSuccess: (queryClient, _, payload) => {
    if (payload.type === 'profile') {
      queryClient.invalidateQueries({ queryKey: ['profile'] });
    }
  },
});

const deleteCv = mutationEndpoint({
  actionName: 'deleteCv',
  mutationKey: ['delete-cv'],
  mutationFn: ({ apiKey }: DeleteCvRequest & { apiKey: string }) =>
    httpClient.auto<DeleteCvResponse>({
      url: `/upload/${apiKey}/cv`,
      method: 'DELETE',
    }),
  onSuccess: (queryClient, _, payload) => {
    if (payload.type === 'profile') {
      queryClient.invalidateQueries({ queryKey: ['profile'] });
    }
    queryClient.invalidateQueries({ queryKey: ['attachments'] });
  },
});

const uploadCvSourceData = mutationEndpoint({
  actionName: 'uploadCvSourceData',
  mutationKey: ['upload-cv-source-data'],
  mutationFn: ({ cv }: { cv: FormData }) =>
    httpClient.auto<UploadCvSourceDataResponse>({
      url: '/api/cv/source-data',
      method: 'POST',
      data: cv,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
});

const uploadLinkedinSourceData = mutationEndpoint({
  actionName: 'uploadLinkedinSourceData',
  mutationKey: ['upload-linkedin-source-data'],
  mutationFn: ({ linkedinUrl }: { linkedinUrl: string }) =>
    httpClient.auto<UploadLinkedinSourceDataResponse>({
      url: '/api/linkedin/source-data',
      method: 'POST',
      data: { linkedinUrl },
    }),
});

export {
  deleteCv,
  getConstants,
  getLocation,
  uploadCv,
  uploadCvSourceData,
  uploadLinkedinSourceData,
};
